var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlockquote = function SvgBlockquote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.492 18.232 2.588-4.504a.7.7 0 0 1-.222.074 1.6 1.6 0 0 1-.255.02q-1.68 0-2.854-1.183-1.173-1.184-1.173-2.844 0-1.68 1.173-2.854 1.173-1.173 2.854-1.173 1.66 0 2.844 1.173 1.185 1.173 1.184 2.854 0 .582-.14 1.081a4 4 0 0 1-.413.955L7.39 18.232zm9.794 0 2.588-4.504a.7.7 0 0 1-.223.074q-.127.02-.254.02-1.68 0-2.854-1.183t-1.174-2.844q0-1.69 1.174-2.86 1.173-1.167 2.854-1.167 1.659 0 2.844 1.173 1.183 1.173 1.183 2.854 0 .582-.14 1.081a4 4 0 0 1-.413.955l-3.686 6.401z"
  })));
};
export default SvgBlockquote;